import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserDataRoutingModule } from './user-data-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserDataComponent } from './user-data.component';
import { ModalCentersComponent } from './modal-centers';
import { ModalStudentCentersComponent } from './modal-student-centers';
import { UserDataAutorComponent } from './user-data-autor/user-data-autor.component';
import { UserDataCentroComponent } from './user-data-centro/user-data-centro.component';
import { UserDataEmpleadorComponent } from './user-data-empleador/user-data-empleador.component';
import { UserDataEstudianteComponent } from './user-data-estudiante/user-data-estudiante.component';
import { UserDataGeneralComponent } from './user-data-general/user-data-general.component';
import { UserDataPadreComponent } from './user-data-padre/user-data-padre.component';
import { UserDataProfesorComponent } from './user-data-profesor/user-data-profesor.component';
import { ImageProfileComponent } from './user-data-general/image-profile/image-profile.component';
import { ModalListCentersComponent } from './modal-list-centers/modal-list-centers.component';


import { NbDialogModule,NbButtonModule, NbCardModule, NbLayoutModule, NbProgressBarModule, NbActionsModule, NbInputModule, NbIconModule, NbSearchModule, NbToggleModule, NbSelectModule, NbDatepickerModule, NbTooltipModule, NbTabsetModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbMomentDateModule   } from '@nebular/moment';
import { UserDataEditorComponent } from './user-data-editor/user-data-editor.component';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { ImguploadComponent } from 'src/app/shared/components/imgupload/imgupload.component';
import { MaterialModule } from 'src/app/pages/material.module';
import { ModalChangePassComponent } from './user-data-general/modal-change-pass/modal-change-pass.component';
import { ModalChangeMobileComponent } from './user-data-general/modal-change-mobile/modal-change-mobile.component';
import { ModalChangeMailComponent } from './user-data-general/modal-change-mail/modal-change-mail.component';
import { ModalDropOutComponent } from './user-data-general/modal-drop-out/modal-drop-out.component';
import { NetworkCheckDirective } from 'src/app/shared/directives/network-check.directive';

@NgModule({
    declarations: [
        UserDataComponent,
        ModalCentersComponent,
        ModalStudentCentersComponent,
        ModalListCentersComponent,
        UserDataAutorComponent,
        UserDataCentroComponent,
        UserDataEmpleadorComponent,
        UserDataEstudianteComponent,
        UserDataGeneralComponent,
        UserDataPadreComponent,
        UserDataProfesorComponent,
        UserDataEditorComponent,
        ImageProfileComponent,
        ModalChangePassComponent,
        ModalChangeMobileComponent,
        ModalChangeMailComponent,
        ModalDropOutComponent
    ],
    imports: [
        CommonModule,
        UserDataRoutingModule,
        SharedModule,
        NbEvaIconsModule,
        NbLayoutModule,
        NbButtonModule,
        NbCardModule,
				NbTabsetModule,
        NbProgressBarModule,
        NbActionsModule,
        NbInputModule,
        NbIconModule,
        NbSearchModule,
        NbToggleModule,
        NbSelectModule,
        NbDatepickerModule,
        NbDialogModule.forChild(),
        NbMomentDateModule,
        NbTooltipModule,
        MaterialModule,
        AlertComponent,
        LoadingComponent,
        ImguploadComponent,
        NetworkCheckDirective,
    ],
    exports: [
        UserDataComponent,
        ModalCentersComponent,
        ModalStudentCentersComponent,
        ModalListCentersComponent,
        UserDataAutorComponent,
        UserDataCentroComponent,
        UserDataEmpleadorComponent,
        UserDataEstudianteComponent,
        UserDataGeneralComponent,
        UserDataPadreComponent,
        UserDataProfesorComponent,
        UserDataProfesorComponent,
        ImageProfileComponent
    ]
})
export class UserDataModule { }
